import React from 'react'

const useAsyncEffect = (
  hookFunction: Function,
  deps?: React.DependencyList
) => {
  React.useEffect(() => {
    let cancelled = false
    const runAsync = (callback: Function) => {
      if (!cancelled) {
        return callback()
      }
      return undefined
    }
    const returnFunction = hookFunction(runAsync)
    return () => {
      cancelled = true
      if (returnFunction !== undefined) {
        returnFunction()
      }
    }
    // the deps array here is dynamic so can't verify whether correct dependencies are being passed
    // need to leave disabled for this case
    // see client/src/lib/useAsyncEffect.tsx also
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}

export { useAsyncEffect }
